import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../DomainTypes';
import { HtmlEditorOptions } from "@singularsystems/neo-notifications";
import PortalTermsAndConditions from "../../Models/PortalUser/PortalTermsAndConditions";
import { NotificationDuration } from "../../../App/Models/NotificationDuration";

export default class PortalTermsAndConditionsVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        private apiClient = AppService.get(Types.Domain.ApiClients.PortalUser)) {

        super(taskRunner);
        this.makeObservable();
    }

    public htmlEditorController: HtmlEditorOptions | null = null;

    public termsAndConditions: PortalTermsAndConditions | null = null;

    public async initialise() {
        const tcs = await this.taskRunner.waitForData(this.apiClient.getTermsAndConditions());

        this.termsAndConditions = PortalTermsAndConditions.fromJSObject<PortalTermsAndConditions>(tcs);

        this.htmlEditorController = new HtmlEditorOptions(this.termsAndConditions.htmlContent);
    }

    public async saveTermsAndConditions(updateEffectiveOn: boolean) {
        if (this.htmlEditorController) {
            await this.taskRunner.run(() =>
                this.apiClient.saveTermsAndConditionsAsync({ htmlContent: this.htmlEditorController!.getOutputHtml(), updateEffectiveOn }));

            this.notifications.addSuccess("Save", "Terms and conditions saved successfully", NotificationDuration.Standard);
            this.termsAndConditions!.portalTermsAndConditionsId = 1;
        }
        
    }
}